import React, { FC, useState, useRef } from 'react';
import translate from '@translate';
import Grid, { GridItem } from 'src/components/Grid';
import Button from 'src/components/Button';
import Typography from 'src/components/Typography';
import { colors, sizes } from 'src/themes/default';
import { FormErrorsType } from '../../types/global';
import { ProductSetItemType } from 'src/types/product';
import ProductSetItemsTable from './ProductSetItemsTable';
import NewProductSetItemBlock from './NewProductSetItemBlock';
import FormBlock from 'src/components/FormBlock';

export interface ProductSetTabPropsType {
    data?: ProductSetItemType[];
    onChange: (value: ProductSetItemType[]) => void;
    disableEdit?: boolean;
    editErrors: FormErrorsType;
}

const ProductSetTab: FC<ProductSetTabPropsType> = (props) => {
    return (
        <>
            <FormBlock sx={{ marginBottom: sizes.blocks_top_MG }}>
                <NewProductSetItemBlock
                    data={props.data || []}
                    onChange={props.onChange}
                    disableEdit={props.disableEdit}
                    editErrors={props.editErrors}
                />
            </FormBlock>
            <ProductSetItemsTable
                data={props.data}
                editErrors={props.editErrors}
                onChange={props.onChange}
                disableEdit={props.disableEdit}
            />
        </>
    );
};

export default ProductSetTab;
